import { render, staticRenderFns } from "./PermissionsInfoModelsList.vue?vue&type=template&id=6bbb9588&"
import script from "./PermissionsInfoModelsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsInfoModelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports